<template>
  <g
    id="MTP12Plug"
    :transform="transform"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns:ev="http://www.w3.org/2001/xml-events"
      xmlns:v="http://schemas.microsoft.com/visio/2003/SVGExtensions/"
      version="1.1" 
      width="500" 
      height="110"
      viewBox="231 396 405 40"
      xml:space="preserve"
      color-interpolation-filters="sRGB"
      class="st5"
    >
    <v:documentProperties v:langID="1031" v:metric="true" v:viewMarkup="false"
      ><v:userDefs
        ><v:ud v:nameU="msvNoAutoConnect" v:val="VT0(1):26" /></v:userDefs
    ></v:documentProperties>
    <g v:mID="0" v:index="1" v:groupContext="foregroundPage">
      <v:pageProperties
        v:drawingScale="0.04"
        v:pageScale="0.04"
        v:drawingUnits="24"
        v:shadowOffsetX="8.50"
        v:shadowOffsetY="-8.50"
      />
      <g
        id="group1-1"
        transform="translate(332.91,1250.79) rotate(180)"
        v:mID="1"
        v:groupContext="group"
      >
        <!-- Guide pins: male only (not shown when plex is unset/null) -->
        <g
          v-if="plex === 'male'"
          id="shape2-2"
          v:mID="2"
          v:groupContext="shape"
          transform="translate(70.64,-6.74)"
        >
          <path
            d="M0.01 841.89 L2.06 841.89 L2.06 841.89 a0.40 0.35 -180 1 0 0 -0.71 L2.06 841.18 L0 841.18 L0.01
							841.89 Z"
            style="fill: #d8d8d8; stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 0.25;"
          />
        </g>
        <g
          v-if="plex === 'male'"
          id="shape3-4"
          v:mID="3"
          v:groupContext="shape"
          transform="translate(70.64,-15.22)"
        >
          <path
            d="M0.01 841.89 L2.06 841.89 L2.06 841.89 a0.40 0.35 -180 1 0 0 -0.71 L2.06 841.18 L0 841.18 L0.01
							841.89 Z"
            style="fill: #d8d8d8; stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 0.25;"
          />
        </g>
        <g
          id="group4-6"
          transform="translate(-1.42,0)"
          v:mID="4"
          v:groupContext="group"
        >
          <g
            id="shape5-7"
            v:mID="5"
            v:groupContext="shape"
            transform="translate(38.14,-0.73)"
          >
            <rect x="0" y="820.67" width="4.51" height="21.22" style="fill: #595959; stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 0.25;" />
          </g>
          <g
            v-if="plex === 'male'"
            id="shape6-9"
            v:mID="6"
            v:groupContext="shape"
            transform="translate(70.77,-6.02)"
          >
            <rect x="0" y="831.24" width="2.12" height="10.65" style="fill: #595959; stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 0.25;" />
          </g>
          <g
            id="shape7-11"
            v:mID="7"
            v:groupContext="shape"
            transform="translate(41.25,0)"
          >
            <rect x="0" y="819.21" width="19.74" height="22.68" :style="`fill: ${effectiveColor}; stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 0.25;`" />
          </g>
          <g
            id="shape8-13"
            v:mID="8"
            v:groupContext="shape"
            transform="translate(886.53,819.21) rotate(90)"
          >
            <path d="M0 841.89 L2.47 841.89" style="stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 0.25; fill: none;" />
          </g>
          <g
            id="shape9-16"
            v:mID="9"
            v:groupContext="shape"
            transform="translate(889.35,819.21) rotate(90)"
          >
            <path d="M0 841.89 L2.47 841.89" style="stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 0.25; fill: none;" />
          </g>
          <g
            id="shape10-19"
            v:mID="10"
            v:groupContext="shape"
            transform="translate(892.18,819.21) rotate(90)"
          >
            <path d="M0 841.89 L2.47 841.89" style="stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 0.25; fill: none;" />
          </g>
          <g
            id="shape11-22"
            v:mID="11"
            v:groupContext="shape"
            transform="translate(886.53,839.42) rotate(90)"
          >
            <path d="M0 841.89 L2.47 841.89" style="stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 0.25; fill: none;" />
          </g>
          <g
            id="shape12-25"
            v:mID="12"
            v:groupContext="shape"
            transform="translate(889.35,839.42) rotate(90)"
          >
            <path d="M0 841.89 L2.47 841.89" style="stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 0.25; fill: none;" />
          </g>
          <g
            id="shape13-28"
            v:mID="13"
            v:groupContext="shape"
            transform="translate(892.18,839.42) rotate(90)"
          >
            <path d="M0 841.89 L2.47 841.89" style="stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 0.25; fill: none;" />
          </g>
          <g
            id="shape14-31"
            v:mID="14"
            v:groupContext="shape"
            transform="translate(899.24,819.21) rotate(90)"
          >
            <path d="M0 841.89 L22.68 841.89" style="stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 0.25; fill: none;" />
          </g>
          <g
            id="shape15-34"
            v:mID="15"
            v:groupContext="shape"
            transform="translate(-799.51,841.89) rotate(-90)"
          >
            <path d="M0 841.89 L22.68 841.89" style="stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 0.25; fill: none;" />
          </g>
          <g
            id="shape16-37"
            v:mID="16"
            v:groupContext="shape"
            transform="translate(911.67,821.68) rotate(90)"
          >
            <path d="M0 841.89 L17.74 841.89" style="stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 0.25;" />
          </g>
          <g
            id="shape17-40"
            v:mID="17"
            v:groupContext="shape"
            transform="translate(61.02,-2.47)"
          >
            <path
              d="M8.76 824.15 L0 824.15 L0 841.89 L8.76 841.89 L9.75 840.83 L9.75 825.21 L8.76 824.15 Z"
              style="fill: #595959; stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 0.25;"
            />
          </g>
          <g
            id="shape18-42"
            v:mID="18"
            v:groupContext="shape"
            transform="translate(34.75,-0.73)"
          >
            <path
              d="M3.39 820.67 L0 827.73 L0 834.83 L3.39 841.89 L3.39 820.67 Z"
              style="fill: #595959; stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 0.25;"
            />
          </g>
        </g>
      </g>
    </g>
    </svg>
  </g>
</template>

<script>
export default {
  name: "MTP12Plug",
  inheritAttrs: false,
  props: {
    transform: String,
    plugColor: String,
    plugType: String,
    plex: [String, Number],
    x: Number,
    y: Number,
    flip: Boolean,
    clip: Boolean,
    width: [String, Number],
    height: [String, Number],
    // MTP12 connector material specification properties
    ferruleType: {
      type: String,
      default: "Keramik", // "Keramik", "Kunststoff", "Metall"
      validator: (value) => ["Keramik", "Kunststoff", "Metall"].includes(value),
    },
    politur: {
      type: String,
      default: "APC", // "PC", "APC", "UPC"
      validator: (value) => ["PC", "APC", "UPC"].includes(value),
    },
    farbe: {
      type: String,
      default: "grün", // "grün", "blau", "rot", "gelb", "schwarz", "grau"
      description: "Color coding per IEC 61754-7",
    },
    clipType: {
      type: String,
      default: "ohne", // "ohne", "MetallClip", "PlastikClip"
      validator: (value) =>
        ["ohne", "MetallClip", "PlastikClip"].includes(value),
    },
  },
  computed: {
    ...require("vuex").mapGetters(["getCssColor"]),

    effectiveColor() {
      return this.getCssColor(this.plugColor);
    },
  },
};
</script>

<style>
svg {
  overflow: visible;
}

.st1 {
  fill: #d8d8d8;
  stroke: #000;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 0.25;
}

.st2 {
  fill: #595959;
  stroke: #000;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 0.25;
}

.st3 {
  fill: #92d050;
  stroke: #000;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 0.25;
}

.st4 {
  stroke: #000;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 0.25;
}

.st5 {
  fill: none;
  fill-rule: evenodd;
  font-size: 12px;
  overflow: visible;
  stroke-linecap: square;
  stroke-miterlimit: 3;
}
</style>
